document.body.addEventListener('foundVariation', (event) => {
    const variation = event.detail.variation;
    window.custom = window.custom || {};
    window.custom.selectedVariant = variation;
});

// Line-item properties for the add, set by snippets/product-custom-form.liquid:
// { 'Pre-order': 'Shipped in a month' } while the variant sells as a pre-order, else {}.
// Sent with the add so the pre-order promise shows in the cart, checkout and the order.
function phlLineProperties() {
    const props = window.phlPreorderProps;
    return props && typeof props === 'object' ? { ...props } : {};
}

document.addEventListener('click', async (e) => {
    if (!window.location.pathname.includes('/products')) return;

    const atcBtn = e.target.closest('#customaddtocart');
    if (!atcBtn) return;

    const variation = window.custom?.selectedVariant;
    if (!variation) return CartToast.show('This variant is out of stock.', 'error');
    if (!variation.available) return CartToast.show('This variant is out of stock.', 'error');

    atcBtn.classList.add('is-loading');
    atcBtn.disabled = true;

    // Open the drawer on tap (it shows its loading state) instead of after the
    // add round trip, so the button responds instantly on slow mobile networks.
    const drawer = window.cartDrawer;
    drawer?.open();

    try {
        const cart = await drawer?.addItem(variation.id, 1, phlLineProperties());
        if (!cart) drawer?.close();
    } finally {
        atcBtn.classList.remove('is-loading');
        atcBtn.disabled = false;
    }
});

// Buy Now listens in the capture phase so it gets the tap before the old Webflow inline
// listener in templates/product.liquid, which clicks the hidden #payinstallment buy-now link.
// That link added the item a second time and raced this code to checkout, so one tap reached
// checkout with 2 units. stopPropagation keeps the tap from reaching that listener.
document.addEventListener('click', async (e) => {
    if (!window.location.pathname.includes('/products')) return;

    const buyBtn = e.target.closest('#custombuynow');
    if (!buyBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const variation = window.custom?.selectedVariant;
    if (!variation) return CartToast.show('This variant is out of stock.', 'error');
    if (!variation.available) return;

    buyBtn.classList.add('is-loading');
    buyBtn.disabled = true;

    const root = window.Shopify?.routes?.root ?? '/';

    try {
        // Keep the shopper's cart (this used to empty it with cart/clear.js, losing other
        // items, gift wrapping and engraving). Add this item only if that variant isn't in
        // the cart yet, so Add to Cart followed by Buy Now doesn't buy two.
        const cart = await fetch(root + 'cart.js').then((res) => res.json());
        const inCart = cart.items?.some((item) => item.variant_id === variation.id);

        const ok = inCart || await window.cartDrawer?._request('cart/add.js', {
            items: [{
                id: variation.id,
                quantity: 1,
                properties: phlLineProperties()
            }]
        });

        if (ok) {
            window.location.href = root + 'checkout';
            return;
        }
    } catch (err) {
        CartToast.show('Network Error — please try again.', 'error');
    }

    // The add failed (_request already showed why): free the button so the shopper can retry.
    buyBtn.classList.remove('is-loading');
    buyBtn.disabled = false;
}, true);

// Coming back from checkout, the browser can restore this page from its back/forward cache
// with Buy Now still disabled and spinning.
window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('#custombuynow').forEach((btn) => {
        btn.classList.remove('is-loading');
        btn.disabled = false;
    });
});
